var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-bar'),_c('main-content'),_c('back-top'),_c('coupon-overlay'),_c('newyear-overlay',{ref:"newyearOverlay"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }